import * as React from 'react'
import * as css from './HeroBgImage.module.css'
import Img from 'components/common/Img'
import HTag from 'components/common/HTag'
import CTALink from 'components/common/CTALink'

const HeroBgImage = ({ heading, link, image }) => (
	<section className={`${css.root} grid bg-suede-black text-center text-white`}>
		<Img className={css.img} image={image} alt={heading?.text} />

		<header className="richtext relative m-auto grid max-w-[640px] px-4 py-12">
			<HTag className="h0" {...heading} />
			{!!link && <CTALink {...link} />}
		</header>
	</section>
)

export default HeroBgImage
